import React, { useState } from "react";
import axios from "axios";
import { useAuth } from "../../../contexts/AuthContext";

function GetMargin({ availableLogins = [] }) {
  const { apiBaseUrl } = useAuth();
  const [formData, setFormData] = useState({
    target: "groups",
    login: "",
  });
  const [responseData, setResponseData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      const response = await axios.post(
        `${apiBaseUrl}/api/admin/final/accounts/margin`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );

      setResponseData(response.data);
      setMessage("اطلاعات Margin با موفقیت دریافت شد");
    } catch (error) {
      console.error("❌ خطا در دریافت Margin:", error);
      setMessage(error.response?.data?.message || "خطا در دریافت اطلاعات");
      if (error.response) {
      }
    } finally {
      setLoading(false);
    }
  };

  const marginData = responseData?.data?.data;

  return (
    <div className="space-y-6 p-6">
      <div className="bg-purple-900/20 border border-purple-600 rounded-lg p-4 mb-6">
        <h3 className="text-xl font-semibold text-white mb-2 flex items-center gap-2">
          <span>📊</span> دریافت اطلاعات Margin
        </h3>
        <p className="text-purple-300 text-sm">
          مشاهده اطلاعات Margin و ریسک یک حساب خاص
        </p>
      </div>

      {message && (
        <div
          className={`p-4 rounded-lg text-center ${
            message.includes("موفقیت")
              ? "bg-green-900 border border-green-600 text-green-400"
              : "bg-red-900 border border-red-600 text-red-400"
          }`}
        >
          {message}
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-6">
        {/* Target Selection */}
        <div className="bg-gray-800 border border-gray-600 rounded-lg p-4">
          <label className="block text-white font-medium mb-3">
            انتخاب نوع حساب (Target):
          </label>
          <div className="flex gap-4">
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="target"
                value="individuals"
                checked={formData.target === "individuals"}
                onChange={(e) =>
                  setFormData({ ...formData, target: e.target.value })
                }
                className="w-5 h-5 accent-blue-600"
              />
              <span className="text-white">Individuals (حساب‌های فردی)</span>
            </label>
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="target"
                value="groups"
                checked={formData.target === "groups"}
                onChange={(e) =>
                  setFormData({ ...formData, target: e.target.value })
                }
                className="w-5 h-5 accent-blue-600"
              />
              <span className="text-white">Groups (گروه‌ها)</span>
            </label>
          </div>
        </div>

        {/* Login Field */}
        <div>
          <label className="block text-white font-medium mb-2">
            Login ID <span className="text-red-400">*</span>
          </label>

          {availableLogins.length > 0 ? (
            <>
              <select
                value={formData.login}
                onChange={(e) =>
                  setFormData({ ...formData, login: e.target.value })
                }
                className="w-full p-3 bg-gray-800 border border-gray-600 rounded-lg text-white focus:border-purple-500 focus:outline-none mb-2"
              >
                <option value="">انتخاب از لیست یا وارد کردن دستی...</option>
                {availableLogins.map((loginObj) => (
                  <option key={loginObj.login} value={loginObj.login}>
                    {loginObj.login}
                    {loginObj.name && ` - ${loginObj.name}`}
                    {` (${loginObj.isActive ? "فعال" : "غیرفعال"})`}
                  </option>
                ))}
              </select>
              <p className="text-gray-400 text-xs mb-2">یا وارد کنید:</p>
            </>
          ) : null}

          <input
            type="text"
            value={formData.login}
            onChange={(e) =>
              setFormData({ ...formData, login: e.target.value })
            }
            placeholder="شماره Login را وارد کنید"
            className="w-full p-3 bg-gray-800 border border-gray-600 rounded-lg text-white placeholder-gray-400 focus:border-purple-500 focus:outline-none"
            required
          />
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          disabled={loading || !formData.login}
          className="w-full py-4 px-6 bg-purple-600 hover:bg-purple-700 disabled:bg-gray-600 text-white font-bold text-lg rounded-lg transition duration-200 flex items-center justify-center gap-3 shadow-lg"
        >
          {loading ? (
            <>
              <div className="animate-spin rounded-full h-6 w-6 border-3 border-white border-t-transparent"></div>
              در حال دریافت...
            </>
          ) : (
            <>
              <span>📊</span>
              دریافت اطلاعات Margin
            </>
          )}
        </button>
      </form>

      {/* Margin Data Display */}
      {marginData && (
        <div className="space-y-6">
          {/* Header Info */}
          <div className="bg-gray-800 border border-gray-600 rounded-lg p-5">
            <h4 className="text-white font-bold text-xl mb-2">
              Login: {marginData.login}
            </h4>
          </div>

          {/* Daily vs Overall Losses */}
          <div className="bg-gray-800 border border-gray-600 rounded-lg p-5">
            <h4 className="text-white font-bold text-lg mb-4 flex items-center gap-2">
              <span>📉</span> Realized Loss
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="bg-gray-700/50 rounded p-4">
                <p className="text-white text-base font-medium mb-3">
                  total_current_daily_realized_loss
                </p>
                <p className="text-red-400 font-bold text-2xl">
                  $
                  {parseFloat(
                    marginData.total_current_daily_realized_loss
                  ).toFixed(2)}
                </p>
              </div>
              <div className="bg-gray-700/50 rounded p-4">
                <p className="text-white text-base font-medium mb-3">
                  total_current_overall_realized_loss
                </p>
                <p className="text-red-400 font-bold text-2xl">
                  $
                  {parseFloat(
                    marginData.total_current_overall_realized_loss
                  ).toFixed(2)}
                </p>
              </div>
            </div>
          </div>

          {/* Total Exposure */}
          <div className="bg-gray-800 border border-gray-600 rounded-lg p-5">
            <h4 className="text-white font-bold text-lg mb-4 flex items-center gap-2">
              <span>🎯</span> Total Exposure
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="bg-gray-700/50 rounded p-4">
                <p className="text-white text-base font-medium mb-3">
                  total_daily_exposure
                </p>
                <p className="text-orange-400 font-bold text-2xl">
                  ${parseFloat(marginData.total_daily_exposure).toFixed(2)}
                </p>
              </div>
              <div className="bg-gray-700/50 rounded p-4">
                <p className="text-white text-base font-medium mb-3">
                  total_overall_exposure
                </p>
                <p className="text-orange-400 font-bold text-2xl">
                  ${parseFloat(marginData.total_overall_exposure).toFixed(2)}
                </p>
              </div>
            </div>
          </div>

          {/* Remaining Allowed Loss */}
          <div className="bg-gray-800 border border-gray-600 rounded-lg p-5">
            <h4 className="text-white font-bold text-lg mb-4 flex items-center gap-2">
              <span>💚</span> Remaining Allowed Loss
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="bg-green-900/20 rounded p-4 border border-green-700/50">
                <p className="text-white text-base font-medium mb-3">
                  daily_remaining_allowed_loss
                </p>
                <p className="text-green-400 font-bold text-2xl">
                  $
                  {parseFloat(marginData.daily_remaining_allowed_loss).toFixed(
                    2
                  )}
                </p>
              </div>
              <div className="bg-green-900/20 rounded p-4 border border-green-700/50">
                <p className="text-white text-base font-medium mb-3">
                  overall_remaining_allowed_loss
                </p>
                <p className="text-green-400 font-bold text-2xl">
                  $
                  {parseFloat(
                    marginData.overall_remaining_allowed_loss
                  ).toFixed(2)}
                </p>
              </div>
            </div>
          </div>

          {/* Margin Utilization & Position Max Loss */}
          <div className="bg-gray-800 border border-gray-600 rounded-lg p-5">
            <h4 className="text-white font-bold text-lg mb-4 flex items-center gap-2">
              <span>📊</span> Utilization & Limits
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="bg-gradient-to-br from-purple-900/30 to-purple-800/20 rounded p-4 border border-purple-700/50">
                <p className="text-white text-base font-medium mb-3">
                  overall_margin_utilization_percent
                </p>
                <p className="text-white font-bold text-3xl">
                  {parseFloat(
                    marginData.overall_margin_utilization_percent
                  ).toFixed(2)}
                  %
                </p>
              </div>
              <div className="bg-gray-700/50 rounded p-4">
                <p className="text-white text-base font-medium mb-3">
                  position_max_allowed_loss
                </p>
                <p className="text-white font-bold text-2xl">
                  ${parseFloat(marginData.position_max_allowed_loss).toFixed(2)}
                </p>
              </div>
            </div>
          </div>

          {/* Raw JSON (Optional - for debugging) */}
          <details className="bg-gray-800 border border-gray-600 rounded-lg p-4">
            <summary className="text-white font-medium cursor-pointer hover:text-purple-400">
              نمایش JSON کامل (برای debugging)
            </summary>
            <pre className="bg-gray-900 p-4 rounded-lg text-gray-300 text-xs overflow-x-auto max-h-96 overflow-y-auto mt-3">
              {JSON.stringify(responseData, null, 2)}
            </pre>
          </details>
        </div>
      )}
    </div>
  );
}

export default GetMargin;
